import { useEffect } from "react";
import { FormState } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

// TODO: https://denislistiadi.medium.com/react-router-v6-preventing-transitions-2389806e8556

/**
 * Hook to check if provided form is dirty and if so show a warning.
 */
const useUnsavedChangesInFormChecker = (formState: FormState<any>) => {
	const h = useNavigate();

	const { t } = useTranslation();

	useEffect(() => {
		let unreg: Function | undefined;
		if (formState.isDirty && Object.keys(formState.dirtyFields).length > 0) {
			// unreg = h.block(t("UNSAVED_CHANGES") as string);
		}
		return () => {
			unreg && unreg();
		};
	}, [h, formState.isDirty, formState.dirtyFields, t]);
};

export default useUnsavedChangesInFormChecker;

export const useUnsavedChangesChecker = (isDirty?: boolean) => {
	const h = useNavigate();
	const { t } = useTranslation();

	useEffect(() => {
		let unreg: Function | undefined;
		if (isDirty) {
			// unreg = h.block(t("UNSAVED_CHANGES") as string);
		}
		return () => {
			unreg && unreg();
		};
	}, [h, isDirty, t]);
};
